import { cva } from "class-variance-authority";

export const badgeVariants = cva(
  "focus:ring-primary inline-flex items-center rounded-full border px-3 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2",
  {
    variants: {
      variant: {
        primary: "border-primary bg-primary text-primary-foreground",
        secondary: "border-secondary bg-secondary text-white",
        error: "border-focus-rose bg-focus-rose text-white",
        warning: "border-focus-warning bg-focus-warning text-white",
        info: "border-info bg-info text-white",
        success: "border-focus-success bg-focus-success text-white",
      },
      outline: {
        true: "bg-transparent",
      },
    },
    compoundVariants: [
      { outline: true, variant: "primary", className: "text-primary" },
      { outline: true, variant: "secondary", className: "text-secondary" },
      { outline: true, variant: "error", className: "text-error" },
      { outline: true, variant: "warning", className: "text-warning" },
      { outline: true, variant: "info", className: "text-info" },
      { outline: true, variant: "success", className: "text-success" },
    ],
    defaultVariants: {
      variant: "primary",
      outline: false,
    },
  },
);
